import { useState, useEffect } from 'react';

const useCatalogueData = () => {
  const [catalogues, setCatalogues] = useState([]);
  const [loadingCatalogue, setLoading] = useState(true);
  const [errorCatalogue, setError] = useState(null);

  useEffect(() => {
    const fetchCatalogue = async () => {
      try {
        const response = await fetch(`https://backend.nuhababy.com/getCatalogue`);
        // const response = await fetch("/api/getCatalogue");
        if (!response.ok) {
          throw new Error("Failed to fetch catalogue");
        }
        const data = await response.json();
        setCatalogues(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCatalogue();
  }, []);

  return { catalogues, loadingCatalogue, errorCatalogue };
};

export default useCatalogueData;
